import { useSelector }  from "react-redux";
import CurrentPage      from "../../../domain/fundamentals/pagination/CurrentPage";
import Pagination       from "../../../domain/fundamentals/pagination/Pagination";
import { ResKaState }   from "../../../index";
import ResKaReduxAction from "../ResKaReduxAction";

enum PlanPaginationActionType {
  TOP_PLAN_PAGINATION = "TOP_PLAN_PAGINATION",
  LAST_PLAN_PAGINATION = "LAST_PLAN_PAGINATION",
  NEXT_PLAN_PAGINATION = "NEXT_PLAN_PAGINATION",
  PREV_PLAN_PAGINATION = "PREV_PLAN_PAGINATION",
  SET_PLAN_PAGINATION = "SET_PLAN_PAGINATION"
}

interface TopPlanPaginationAction extends ResKaReduxAction {
}

interface LastPlanPaginationAction extends ResKaReduxAction {
}

interface NextPlanPaginationAction extends ResKaReduxAction {
}

interface PrevPlanPaginationAction extends ResKaReduxAction {
}

interface SetPlanPaginationAction extends ResKaReduxAction {
  pagination: Pagination;
}

type PlanPaginationAction =
  TopPlanPaginationAction
  | LastPlanPaginationAction
  | NextPlanPaginationAction
  | PrevPlanPaginationAction
  | SetPlanPaginationAction
  ;

export const topPlanPaginationAction = (): TopPlanPaginationAction => ({
  type: PlanPaginationActionType.TOP_PLAN_PAGINATION,
});

export const lastPlanPaginationAction = (): LastPlanPaginationAction=> ({
  type: PlanPaginationActionType.LAST_PLAN_PAGINATION,
});

export const nextPlanPaginationAction = (): NextPlanPaginationAction => ({
  type: PlanPaginationActionType.NEXT_PLAN_PAGINATION,
});

export const prevPlanPaginationAction = (): PrevPlanPaginationAction => ({
  type: PlanPaginationActionType.PREV_PLAN_PAGINATION,
});

export const setPlanPaginationAction = (pagination: Pagination): SetPlanPaginationAction => ({
  type: PlanPaginationActionType.SET_PLAN_PAGINATION,
  pagination: pagination,
});

export const planPaginationReducer = (state: Pagination = new Pagination(), action: PlanPaginationAction): Pagination => {
  switch (action.type) {
    default:
      return state;
    case PlanPaginationActionType.TOP_PLAN_PAGINATION:
      return new Pagination(new CurrentPage(), state.total);
    case PlanPaginationActionType.LAST_PLAN_PAGINATION:
      return new Pagination(new CurrentPage(state.total.value), state.total);
    case PlanPaginationActionType.NEXT_PLAN_PAGINATION:
      return new Pagination(state.current.next(), state.total);
    case PlanPaginationActionType.PREV_PLAN_PAGINATION:
      return new Pagination(state.current.prev(), state.total);
    case PlanPaginationActionType.SET_PLAN_PAGINATION:
      return (action as SetPlanPaginationAction).pagination;
  }
};

export const usePlanPagination = (): Pagination => useSelector((state: ResKaState) => state.planPagination);
